import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  output,
  signal,
} from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { EVENT_PALETTE } from '@principle-theorem/shared';
import { isEqual } from 'lodash';
import { ColourSelectorComponent } from '../colour-selector/colour-selector.component';

@Component({
  selector: 'pt-event-colour-picker',
  templateUrl: './event-colour-picker.component.html',
  styleUrls: ['./event-colour-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatMenuModule, ColourSelectorComponent],
})
export class EventColourPickerComponent {
  colour = input<string | undefined>();
  opacityMin = input(0.2);
  disableOpacity = input(false);
  enableCustomInput = input(false);
  colourChanged = output<string | undefined>();
  disabled = input(false);
  palette = input<string[]>(EVENT_PALETTE);

  selectedColour = signal<string | undefined>(undefined, { equal: isEqual });

  constructor() {
    effect(() => {
      this.selectedColour.set(this.colour());
    });
  }

  save(): void {
    const hasColourChanged = this.selectedColour() !== this.colour();

    if (hasColourChanged) {
      this.colourChanged.emit(this.selectedColour());
    }
  }
}
